import { render, staticRenderFns } from "./advantagesDetail2.vue?vue&type=template&id=09c85972&scoped=true&"
import script from "./advantagesDetail2.vue?vue&type=script&lang=js&"
export * from "./advantagesDetail2.vue?vue&type=script&lang=js&"
import style0 from "./advantagesDetail2.vue?vue&type=style&index=0&id=09c85972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c85972",
  null
  
)

export default component.exports